<script type="text/ecmascript-6">
//import $ from "jquery";
import userInfoApi from '@/api/userInfo'
import watchLogApi from '@/api/watchLog'
import vue from "vue";
import axios from "axios";
import qs from 'qs';
vue.prototype.qs = qs;
vue.prototype.$axios = axios;
export default {
  props: {
    ccsrc: {
      type: String
    },
    ccPic:{
      type: String
    },
      /*
* playType: 1剧集播放
* playUserId :观看用户ID
* isCutTime:是否减去观影时间
* */
      playResId:{
          type: Number
      },
      playType:{
          type: Number
      },
      playUserId:{
          type: Number
      },
      isCutTime:{
          type: Boolean
      },
      playResName:{
          type: String
      },
      playUserName:{
          type: String
      },
  },
  data () {
    return {
        beforeUnload_time:0,
        gap_time:0,
        playTime:0,
        viewTime:0,
        firstPlay:true, //当前页第一次点击播放
        //观看记录
        queryParam:{
            id:0,
            userId:0,       //观看人ID
            resourceType:0, //资源类型
            resourceId:0,   //资源ID
            watchTime:'',
        }
    }
  },
  render (createElement) {
    return createElement(
      'div',
      {
        attrs: {
          class: 'container'
        }
      },
      [
        createElement(
          'script',
          {
            attrs: {
              type: 'text/javascript',
              src: this.ccsrc
            }
          }
        )
      ]
    )
  },
    mounted() {
      //创建监听
        window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
        window.addEventListener('unload', e => this.unloadHandler(e))

    },
    created(){
        this.setPlayerCallBack();
    },
    destroyed() {
      //注销监听
        window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
        window.removeEventListener('unload', e => this.unloadHandler(e))
    },
    methods:{
        beforeunloadHandler(){
            this.beforeUnload_time=new Date().getTime();

            this.setViewTime()


        },
        //窗口 刷新/关闭
        unloadHandler(e){
            this.gap_time=new Date().getTime()-this.beforeUnload_time;
            this.doEnd()  //调用关闭接口

            clearInterval(this.timer)
            clearInterval(this.viewer)
           // console.log("调用了结束函数")
            // if(this.gap_time<=5){
            //     console.log('关闭')
            // }else{
            //     console.log('刷新')
            // }
        },
        setPlayerCallBack() {
            if(window.cc_js_Player){
              window.cc_js_Player.destroy()
            }

            window.onCCH5PlayerLoaded = true
            window.on_CCH5player_ready = this.onPlayerReady;
            window.on_switch_quality = this.onSwitchQuality;
            window.on_CCH5player_play = this.onPlay;
            window.on_CCH5player_ended = this.onEnd;
            window.on_CCH5player_pause = this.onPause;
        },
        onPlayerReady(obj) {
            console.log('CCH5player_ready', obj)
            //window.cc_js_Player.setQuality(5);

            //设置封面图为 默认图片
            if(this.ccPic){
                let player = document.getElementsByClassName("ccH5Poster")[0]
                player.innerHTML = ""
                var img = new Image();//创建一个标签
                img.setAttribute('src',this.ccPic);//给标签定义src链接
                // img.setAttribute('src', 'http://sunjinyu.cn/images/lazy/114.jpg');
                img.style.opacity = '0';
                player.appendChild(img);//放到指定的id里

                this.setPlayer = setInterval(function () {
                    let imgWidth = img.naturalWidth,
                        imgHeight = img.naturalHeight;
                    if(img.naturalWidth && img.naturalHeight){
                        if(imgWidth > imgHeight){
                            img.style.width = '100%';
                            img.style.height = 'auto';
                        } else {
                            img.style.width = 'auto'
                            img.style.height = '100%';
                        }
                        img.style.opacity = '1'
                        img.style.margin = '0';
                        clearInterval(this.setPlayer)
                    }
                }, 100)
            }

        },
        doPlay(){
            window.cc_js_Player.play()
        },
        onPlay(video, vid){
            if(this.firstPlay && this.playUserId !=0){
                //第一次点击观看，添加观影记录，同时改为 false
                if(this.playType != undefined){
                    this.queryParam.userId = this.playUserId
                    this.queryParam.resourceType = this.playType
                    this.queryParam.resourceId = this.playResId

                    watchLogApi.selectByParam(this.queryParam).then(re=>{
                        if(re.response !=null){
                            this.queryParam = re.response

                        }
                        watchLogApi.update(this.queryParam).then( reUpdate =>{
                            //console.log("reUpdate===",reUpdate)
                        })

                    })
                }

                this.firstPlay = false
            }
            if(this.isCutTime){
                this.timer = setInterval(this.subtractTimes, 1000);
            }

            this.viewer = setInterval(() => {
                this.viewTime = this.viewTime + 1
                //console.log("viewTime=============",this.viewTime)
            }, 1000)

            //console.log("Play回调", vid, video);
        },
        onPause(video, vid){
          console.log('video, vid',video, vid)
            if(this.isCutTime){
                clearInterval(this.timer)
            }
            clearInterval(this.viewer)

            //console.log("Play回调", vid, video);
        },
        subtractTimes(){
            if(this.playTime == 60){
                this.playTime = 0
            }
            if(this.playTime == 0){
                const formData = new FormData() // 创建form对象
                formData.append('userId', this.playUserId)// 通过append向form对象添加数据
                formData.append('minutes', 1)// 通过append向form对象添加数据
                userInfoApi.subtractTimes(formData).then(re => {
                    console.log("剩余时长：",re.response.remainDuration)
                    if(re.response.remainDuration == 0){
                        clearInterval(this.timer)
                        this.$parent.showTimeTipsByType()
                    }
                })
            }
            this.playTime +=1
            //console.log("=-=-=-=-=-=-=-=-=-",this.playTime)
        },
        onEnd(video, vid){
            //console.log("End回调", vid, video,window.cc_js_Player.getPosition());
            console.log("End回调",window.cc_js_Player.jumpToTime(0)); //跳转到0秒


            this.setViewTime()

            clearInterval(this.timer)
            clearInterval(this.viewer)

            this.viewTime =0

            //console.log("11111111111")
            //this.$parent.reloadCCPart(); //重新加载视频组件

            /*//调用父组件下一课节方法
            if(typeof this.$parent.nextSection != 'undefined' && this.$parent.nextSection instanceof Function){
                this.$parent.nextSection();
            }*/

        },

        setViewTime(){
            //this.$parent.setViewTime(this.playUserId,this.playResId,this.playResName,this.playUserName,this.viewTime)
            //console.log("=========================",this.viewTime)
            if(this.playUserId !=0){
                let viewDurationUrl = '/rrbi/dataBoard/viewDuration'
                let postData={
                    "userId":this.playUserId,
                    "objectId":this.playResId,
                    "objectType":1, //1是放映厅剧集
                    "objectName":this.playResName,
                    "userName":this.playUserName,
                    "viewDuration":this.viewTime
                }
                this.$axios.post(viewDurationUrl,qs.stringify(postData)).then(function(){
                    //console.log("调用>>>>>>>视频观看记录   通用接口=============返回结果：")
                })


            }
        },

        doEnd(){
            //console.log("关闭/刷新页面调用End",window.cc_js_Player.getPosition());
        },
        onSwitchQuality(vid, quality) {
            //console.log("切换清晰度回调", vid, quality);
        }
    }
}
</script>

<style lang="less">
.dialog-iframe{
  .container{
    table{
      margin: 0 auto !important;
    }
  }
}
</style>
